import { FormFieldHelp } from "@/features/post/components/forms/FormFieldHelp";

export interface MobileFormFieldProps {
  label: string;
  labelId: string;
  groupContent?: boolean;
  helpText?: string;
  children: React.ReactNode;
}

/** スマートフォン版フォームの小見出しと入力内容を一貫した配置で描画する。 */
export const MobileFormField: React.FunctionComponent<MobileFormFieldProps> = ({
  label,
  labelId,
  helpText,
  children,
}: MobileFormFieldProps) => (
  <fieldset className="space-y-1">
    <legend className="flex items-center gap-1 whitespace-nowrap">
      <b id={labelId} className="text-xs font-medium text-foreground">
        {label}
      </b>
      {helpText && (
        <FormFieldHelp label={label} helpText={helpText} className="ml-0" />
      )}
    </legend>
    {children}
  </fieldset>
);

MobileFormField.displayName = "MobileFormField";
